import { StyleSheet } from "@react-pdf/renderer";

export const certstyle = StyleSheet.create({
  header: {
    borderBottom: 1,
  },

  section: {
    borderTop: 1,
    borderBottom: 1,
    marginTop: 10,
    paddingTop: 5,
    paddingBottom: 5,
  },

  title: {
    fontWeight: 700,
    marginBottom: 3,
    textDecoration: "underline",
  },

  resultSection: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    fontSize: 9,
  },

  resultRow: {
    width: "20%",
    paddingHorizontal: 2,
    paddingVertical: 1,
    textAlign: "center",
  },

  footer: {
    width: "100%",
    position: "absolute",
    fontSize: 10,
    padding: 20,
    paddingTop: 0,
    bottom: 0,
    left: 0,
  },
});
